export const contact = {
  contactHero: {
    title: 'INQUIRY',
    subtitle: 'Contact Secretariat',
    description1: 'We accept consultations regarding organizational transformation or your own structural growth.',
    description2: 'To accommodate access from around the world, the secretariat will respond within 3 business days (JST) in principle.',
  },
  form: {
    title: 'Contact Form',
    name: 'Name',
    namePlaceholder: 'Your name',
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    organization: 'Organization / Affiliation',
    organizationPlaceholder: 'Company name or educational institution name',
    departmentTitle: 'Department / Title',
    departmentTitlePlaceholder: 'e.g. Sales Department, Manager',
    inquiryType: 'Inquiry Type',
    selectPlaceholder: 'Please select',
    inquiryTypes: {
      individual: 'Individual Program Inquiry',
      corporate: 'Corporate Training',
      educational: 'Educational Institution Implementation',
      seminar: 'Seminar / Workshop',
      other: 'Other',
    },
    message: 'Message',
    messagePlaceholder: 'Please describe your inquiry in detail',
    submit: 'Submit',
    submitting: 'Submitting...',
    success: 'Your inquiry has been submitted. We will contact you within 3 business days.',
    error: 'An error occurred during submission. Please try again.',
    charCount: '{{count}} / 500 characters',
    gratitudeMessage1: 'We are deeply grateful that you have resonated with our philosophy and found your way here. We look forward to embarking together on a new future guided by education and structure.',
    gratitudeMessage2: '"We extend our deepest gratitude for your resonance with our philosophy. We look forward to embarking on a journey toward a newly structured future together."',
  },
};